import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { customerProfileDetailsUpdateMobilePatch } from '../../../../api-client/api-gqcust-client';

const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const patchCustomerProfileDetailsUpdateMobile = createAsyncThunk(
    'patchCustomerProfileDetailsUpdateMobile/Patch',
    async (body, { rejectWithValue }) => {
        try {
            const response = await customerProfileDetailsUpdateMobilePatch(body);
            const data = response.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'PATCH_GQ_CUSTOMER_PROFILE_DETAILS_UPDATE_MOBILE_FAILURE',
                error: err,
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    },
);

export const patchCustomerProfileDetailsUpdateMobileSlice = createSlice({
    name: 'patchCustomerProfileDetailsUpdateMobile',
    initialState,
    extraReducers: {
        [patchCustomerProfileDetailsUpdateMobile.pending]: (state) => {
            state.loading = true;
        },
        [patchCustomerProfileDetailsUpdateMobile.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload?.data;
        },
        [patchCustomerProfileDetailsUpdateMobile.rejected]: (state, { payload }) => {
            state.loading = false;
            state.data = null;
            state.error = payload;
        },
    },
});

export const patchCustomerProfileDetailsUpdateMobileSelector = (state) => state.patchCustomerProfileDetailsUpdateMobile;
export const patchCustomerProfileDetailsUpdateMobileReducer = patchCustomerProfileDetailsUpdateMobileSlice.reducer;
